<template>
  <div>
    <div id="oauth-success" class="flex center" style="flex-direction:column">
      <img width="450" src="@/assets/img/happy.png" />
      <h3>Tag Hot Tracker Instalada com sucesso!</h3>
      <p>
        Estamos prontos para começar a captaturar os dados dos visitantes da sua página. 
      </p>

      <div class="buttons small">
        <div @click="openPanel()" class="button secondary">
          Acessar o Painel
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import logo4 from "@/assets/img/integration/logo-4.png";

export default {
  name: "verified-tag",
  data() {
    return {
      // logo: logo4
    };
  },
  methods: {
    openPanel() {
      window.location.href= "https://app.unicotracker.com.br"
    },
  },
};
</script>

<style lang="scss" scoped>
#oauth-success {
  padding-top: 30px;
  align-items: center;
  img {
    margin-bottom: 30px;
  }
  .buttons {
    margin-top: 30px;
  }
}
</style>
